// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import Mobile from './mixing/mobile'
import VueCurrencyFilter from 'vue-currency-filter'
import axios from 'axios';
import './main.scss';
import store from './store';
import Toasted from 'vue-toasted';
import VueSweetalert2 from 'vue-sweetalert2';
import InfiniteLoading from 'vue-infinite-loading';


Vue.config.productionTip = false



Vue.use(axios);
Vue.use(Toasted);
Vue.use(VueSweetalert2);
Vue.use(InfiniteLoading, { /* options */ });

Vue.use(VueCurrencyFilter, {
  symbol: '$',
  thousandsSeparator: ',',
  fractionCount: 2,
  fractionSeparator: '.',
  symbolPosition: 'front',
  symbolSpacing: true
});

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>',
  mixins: [Mobile]
})



// WEBPACK FOOTER //
// ./src/main.js